export const iconFontAwesomeCharityGlobe = (
	<i className="fa-solid fa-globe"></i>
);
